import { Component, Vue } from "vue-property-decorator";
import {
  MessageType,
  UserReceiveMessageType,
  UserSendMessageType,
} from "@/resources/constants/graphicClient/graphicClient";
import { Store } from "vuex";
import { ROOM_TYPE, USER_TYPE } from "@/resources/constants/space";
import { RED } from "@/resources/constants/busyReasons";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { i18n } from "@/resources/locales";
import { TIME_ZONE_EN } from "@/resources/constants/timeZone.en";
import { TIME_ZONE_ES } from "@/resources/constants/timeZones.es";
import moment from "moment-timezone";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import { mixins } from "vue-class-component";
import Loader, { CANCELLATION_TIME } from "@/resources/mixins/loader/loader";
import { EMOJIS } from "@/resources/constants/graphicClient/emojis";
import { CHAT_TYPE } from "@/resources/constants/chat";
import NotificationEvent from "../notifications/notificationEvent";
import ConnectToRoomCall from "../chime/connectToRoomCall";
import PusherSocket from "@/helpers/socket/pusher.socket";
import RoomSocketHandler from "@/helpers/socket/handlers/roomSocket.handler";
import poll from "@/store/modules/poll";

export default class UserHandler extends mixins(
  Loader,
  NotificationEvent,
  ConnectToRoomCall,
  PusherSocket
) {
  async handleMessage(
    message: string,
    value?: any | null,
    store?: Store<any>,
    vs?: any,
    others?: any,
  ): Promise<void> {
    switch (message) {
      case UserReceiveMessageType.USER_GUEST_GO_TO_ROOM: {
        break;
      }
      case UserReceiveMessageType.USER_CONNECT_TO_ROOM_CALL: {
        const isCall = store?.getters["SidebarStore/getOpenCall"];
        if (isCall) {
          this.onWarning(
            i18n.t(""),
            i18n.t("notifications.warningMessages.youAreOnCall"),
            "none"
          );
          return;
        }
        const space = store?.getters["SpaceStore/getSpace"];
        const room = space.scenario.rooms.filter(
          (room) => room.id === value
        )[0];

        if (!others)
          store?.dispatch("SystemStore/setCurrentRoomAction", room);
        const currentRoom = store?.getters["SystemStore/getCurrentRoom"];
        if (currentRoom && currentRoom.id !== value)
          return;

        if (room && room.type && room.type === ROOM_TYPE.TEACHER) {
          const localUser = store?.getters["UserStore/getSpaceUser"];
          if (localUser && (localUser.hawkingsType === USER_TYPE.TEACHER || localUser.hawkingsType === USER_TYPE.STAFF))
            store?.dispatch("SystemStore/setEducationToolModalAction", true);
        }

        store?.dispatch("SpaceStore/getRoomAction", {
          roomId: value,
          callback: async (data) => {
            store?.dispatch("SystemStore/setCurrentRoomAction", data);
            ///CHECK ROOM 
            await store.dispatch("GraphicClientStore/inTheSpace", room.id);
            if (localStorage.getItem("inTheRoom") == "false")
              return;
            if (data.poll)
              this.pollUpdate(store, data);
            //TODO POLL /////////////////
            await this.subscribePrivateRoomChannel(room.id, store);
            //////////////////////////////
            if (!data.hasPin) {
              store?.dispatch(
                "MeetingStore/setIsVideoUrlLockedByAdminAction",
                data.isVideoUrlLockedByAdmin
              );
              if (room.type === ROOM_TYPE.WEBINAR) {
                await store.dispatch("GraphicClientStore/inTheSpace", room.id);
                if (localStorage.getItem("inTheRoom") == "false")
                  return;
                store?.dispatch("WebinarStore/setHasPinAction", null);
                store?.dispatch("WebinarStore/setRoomIdAction", value);
                store?.dispatch("WebinarStore/setShowEnterModalAction", true);
              } else {
                store?.dispatch("SystemStore/setOpenNotepadButtonAction", data.hasNotes);
                //LOAD GAME CTTI
                if (space) {
                  let currentRoom = space.scenario.rooms.filter(
                    (a) => a.id === room.id
                  )[0];
                  if (space.superSpace && space.superSpace.company == "CTTI" &&
                    space.scenario.scenarioType.name == "RECREATIVE" &&
                    currentRoom.graphicClientRoomId == 1) {
                    store?.dispatch("SystemStore/setCttiGameModalAction", true);
                  }
                }
                this.connectToRoomCall(store, value);
                if (space && space.superSpace && space.superSpace.company == "HAWKINGS") {
                  if (data.bot != null) {
                    store?.dispatch("SystemStore/setEducationBotIdAction", data.bot.id);
                    store?.dispatch("SystemStore/setEducationModalAction", true);
                  }
                }
              }
            } else {
              if (room.type === ROOM_TYPE.WEBINAR) {
                await store.dispatch("GraphicClientStore/inTheSpace", room.id);
                if (localStorage.getItem("inTheRoom") == "false")
                  return;
                store?.dispatch("WebinarStore/setHasPinAction", data.hasPin);
                store?.dispatch("WebinarStore/setRoomIdAction", value);
                store?.dispatch("WebinarStore/setShowEnterModalAction", true);
              } else {
                store?.dispatch("MeetingStore/setRoomIdAction", value);
                store?.dispatch("SystemStore/setShowPinRoomModalAction", true);
                store?.dispatch("SystemStore/setIsChangePinAction", false);
              }
            }
          },
          callbackError: (err) => {
            // do nothing
          },
        });
        break;
      }
      case UserReceiveMessageType.USER_CONNECT_TO_ROOM_NORMAL: {
        await store?.dispatch("SpaceStore/getRoomAction", {
          roomId: value,
          callback: async (data) => {
            if (!data.hasPin) {
              const space = store?.getters["SpaceStore/getSpace"];
              if (space && space.superSpace && space.superSpace.company == "HAWKINGS") {
                if (data.bot != null) {
                  await store?.dispatch("SystemStore/setEducationBotIdAction", data.bot.id);
                  await store?.dispatch("SystemStore/setEducationModalAction", true);
                }
              }
              store?.dispatch("SystemStore/setOpenNotepadButtonAction", data.hasNotes);
              store?.dispatch("SystemStore/setCurrentRoomAction", data);
            }
          },
          callbackError: (err) => {
            // do nothing
          },
        });
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("USER_CONNECT_TO_ROOM_NORMAL");
        break;
      }
      case UserReceiveMessageType.USER_DISCONNECT_FROM_ROOM_CALL: {
        localStorage.setItem("pin", null);
        const currentRoom = store.getters["SystemStore/getCurrentRoom"];
        store?.dispatch("MeetingStore/setCountPlayerInCallAction", 1);
        //TODO POLL
        await this.unSubscribePrivateRoomChannel(currentRoom.id, store);
        //TODO DELETE NOTIFICATION MESSAGE ROOM
        store.dispatch("ChatStore/removeUnSeenMessageAction", {
          id: null,
          type: CHAT_TYPE.ROOM,
        });
        //-------------------------------------
        if (currentRoom && currentRoom.id == value) {
          store?.dispatch("SystemStore/setOpenNotepadButtonAction", false);
          store?.dispatch("SystemStore/setCurrentRoomAction", null);
        }
        if (currentRoom && currentRoom.type === ROOM_TYPE.TEACHER) {
          return;
        }
        try {
          const meetingType = store?.getters["MeetingStore/getMeetingType"];
          store?.dispatch("UserStore/loadPreviousStatusAction", {
            store: store,
            callback: (response) => {
              store?.dispatch("SpaceStore/updateUserInSpace", response.data);
            },
          });
          if (meetingType !== MEETING_TYPE.WEBINAR) {
            store?.dispatch("WebinarStore/setRoomIdAction", null);
          }
          if (meetingType !== MEETING_TYPE.SPEED_NETWORKING) {
            store?.dispatch("SystemStore/setOpenNotepadModalAction", false);
            await store?.dispatch("MeetingStore/leaveMeetingAction", {
              roomId: value,
              callback: async (response) => {
                await store?.dispatch("ChatStore/leaveRoomChatAction", value);
                await store?.dispatch("SidebarStore/setOpenCall", false);
                await store?.dispatch("ChatStore/setMinimizeChatAction", false);
              },
              callbackError: (error) => {
                console.log("Error USER_DISCONNECT_FROM_ROOM_CALL ", error);
                store?.dispatch("ChatStore/leaveRoomChatAction", value);
                store?.dispatch("SidebarStore/setOpenCall", false);
                store?.dispatch("ChatStore/setMinimizeChatAction", false);
              },
            });
          } else {
            store?.dispatch("SpeedNetworkingStore/leaveSpeedNetworkingAction", {
              roomId: value,
              callback: async () => {
                await store?.dispatch("SidebarStore/setOpenCall", false);
                await store?.dispatch("ChatStore/setMinimizeChatAction", false);
                await store?.dispatch(
                  "SpeedNetworkingStore/setEnterInNetworkingAction",
                  false
                );
                await store?.dispatch("MeetingStore/closeMeetingSession");
              },
            });
          }
        } catch (error) {
          console.log("USER_DISCONNECT_FROM_ROOM_CALL ", error);
        }

        await store?.dispatch("ChatStore/setMessagesAction", []);
        await store?.dispatch("MeetingStore/setRoomIdAction", 0);
        await store?.dispatch("MeetingStore/setRoomNameAction", "");
        await store?.dispatch("SidebarStore/setOpenChatAction", false);
        await store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
        await store?.dispatch("MeetingStore/setMeetingTypeAction", "");
        await store?.dispatch("MeetingStore/setIsFirstConnectionAction", false);
        break;
      }
      case UserReceiveMessageType.USER_DISCONNECT_FROM_ROOM_NORMAL: {
        localStorage.setItem("pin", null);
        const currentRoom = store.getters["SystemStore/getCurrentRoom"];
        if (currentRoom && currentRoom.id == value) {
          store?.dispatch("SystemStore/setOpenNotepadButtonAction", false);
          store?.dispatch("SystemStore/setCurrentRoomAction", null);
          //TODO POLL
          await this.unSubscribePrivateRoomChannel(currentRoom.id, store);
        }
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("USER_DISCONNECT_FROM_ROOM_NORMAL");
        break;
      }
      case UserReceiveMessageType.USER_CALL_ONE_TO_ONE: {
        const isCall = store?.getters["SidebarStore/getOpenCall"];
        if (isCall) {
          this.onWarning(
            i18n.t(""),
            i18n.t("notifications.warningMessages.youAreOnCall"),
            "none"
          );
          return;
        }
        const userLocal = store?.getters["UserStore/getSpaceUser"];
        const users = store?.getters["SpaceStore/getUsersInDraw"];
        const user = users.filter((a) => a.superSpaceUser.user.id === value)[0];
        let loading = null;
        if (user && user.superSpaceUser.user.availableStatus != RED.type) {
          await store?.dispatch("GraphicClientStore/callOneToOneOk", value);
          loading = vs.loading({
            type: "circles",
            background: "#000",
            color: "#fff",
          });
        }

        await store?.dispatch("MeetingStore/closeMeetingSession");
        await store?.dispatch("MeetingStore/createMeetingOneToOneAction", {
          userId: user.id,
          callback: async (response) => {
            if (user && user.superSpaceUser.user.availableStatus != RED.type) {
              const pre_status = {
                availableStatus: userLocal.superSpaceUser.user.availableStatus,
                availableStatusReason:
                  userLocal.superSpaceUser.user.availableStatusReason,
                emoji: userLocal.superSpaceUser.user.emoji,
              };
              localStorage.setItem("pre_status", JSON.stringify(pre_status));
              if (userLocal?.superSpaceUser.user.emoji != "U+1F4DE") {
                await store?.dispatch("UserStore/updateUserStatusAction", {
                  userId: userLocal.superSpaceUser.user.id,
                  props: {
                    availableStatus: RED.type,
                    availableStatusReason: null,
                    emoji: "U+1F4DE",
                  },
                  callback: (user) => {
                    store?.dispatch("SpaceStore/updateUserInSpace", user);
                  },
                });
              }
              loading.close();
              await store?.dispatch(
                "MeetingStore/setMeetingDataAction",
                response.data
              );
              await store?.dispatch("SidebarStore/setOpenCall", true);
              await store?.dispatch(
                "ChatStore/setMinimizeChatAction",
                !store?.getters["UserStore/getConfig"].chat
                  .openRoomChatByDefault
              );
              await store?.dispatch(
                "MeetingStore/setMeetingTypeAction",
                MEETING_TYPE.ONE_TO_ONE
              );
              await store?.dispatch("ChatStore/setUserChatAction", user);
              setTimeout(() => {
                store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
              }, 20);
            } else if (user) {
              this.onWarning(
                i18n.t(""),
                i18n.t("notifications.warningMessages.isBusy", {
                  name: user.superSpaceUser.user.name,
                }),
                "none"
              );
            }
          },
          callbackError: async (error) => {
            if (loading) loading.close();
            console.log("Error createMeetingOneToOneAction ", error);
          },
        });

        break;
      }
      case UserReceiveMessageType.USER_CHAT_ONE_TO_ONE: {
        await store?.dispatch("ChatStore/setMessagesAction", []);
        const user = store?.getters["SpaceStore/getUsersInSpace"].filter(
          (a) => a.user.id === value
        )[0];
        await store?.dispatch("ChatStore/setUserChatAction", user);
        await store?.dispatch("SidebarStore/setOpenChatAction", false);
        await store?.dispatch(
          "ChatStore/setChatTypeAction",
          CHAT_TYPE.ONE_TO_ONE
        );
        await store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
        await store?.dispatch("SidebarStore/setOpenChatAction", true);
        await store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
        await store?.dispatch("ChatStore/removeUnSeenMessageAction", {
          id: user.id,
        });
        break;
      }
      case UserReceiveMessageType.USER_SHOW_USER_INFO: {
        const user = store.getters["SpaceStore/getUsersInDraw"].filter(
          (a) => a.superSpaceUser.user.id === value
        )[0];
        await store.dispatch(
          "SystemStore/setUserInfoIdAction",
          user.superSpaceUser.id
        );
        await store.dispatch("SystemStore/setOpenUserInfoModalAction", true);
        break;
      }
      case UserReceiveMessageType.USER_SEND_PAPER_PLANE: {
        const user = store?.getters["SpaceStore/getUsersInDraw"].filter(
          (a) => a.superSpaceUser.user.id === value.id
        )[0];

        const localUser = store?.getters["UserStore/getSpaceUser"];
        if (value.isMessage) {
          store?.dispatch("SystemStore/setUserPaperPlaneIdAction", user.id);
          store?.dispatch(
            "SystemStore/setSuperSpaceUserPaperPlaneIdAction",
            user.superSpaceUser.id
          );
          store?.dispatch("SystemStore/setOpenPaperPlaneModalAction", true);
        } else {
          const data = {
            message: "",
            type: "THROW_PAPER_PLANE",
            color: "BLUE",
            sound: "NO_SOUND",
            hasConfirmation: false,
            spaceUsers: [{ id: user.id }],
          };
          store?.dispatch("SpaceStore/sendConsoleMessageAction", {
            spaceId: store?.getters["SpaceStore/getSpace"].id,
            data,
            callback: () => {
              store?.dispatch("GraphicClientStore/sendPaperPlaneAction", {
                sendId: localUser.superSpaceUser.user.id,
                receiveId: value.id,
              });
              const audio = new Audio(require("@/assets/audio/goofy.mp3"));
              audio.autoplay = true;
              audio.play();
              this.$vs.notification({
                icon: '<i class="fas fa-paper-plane" style="color: #2b3d8e"></i>',
                border: "primary",
                duration: 4000,
                clickClose: true,
                title: i18n.t("notifications.sendNewPaperPlane"),
                text: `<p style="text-align: end;font-size: 10px">${i18n.t(
                  "labels.sentAt"
                )} ${moment().format("HH:mm")}</p>`,
                onDestroy: () => {
                  audio.pause();
                },
              });
            },
          });
        }
        break;
      }
      case UserReceiveMessageType.USER_GET_TIMEZONE_UTC_OFFSET: {
        const user = store?.getters["SpaceStore/getUsersInDraw"].filter(
          (a) => a.superSpaceUser.user.id === value
        )[0];
        if (!user) return;
        GraphicClient.sendMessage(
          MessageType.USER,
          UserSendMessageType.SET_TIMEZONE_UTC_OFFSET,
          {
            id: user.superSpaceUser.user.id,
            offset:
              moment.tz(user.superSpaceUser.user.timezone).utcOffset() * 60000,
          }
        );
        break;
      }
      case UserReceiveMessageType.USER_SAVE_POSITION: {
        const user = store?.getters["UserStore/getSpaceUser"];
        store?.dispatch("UserStore/saveSpaceUserPositionAction", {
          userId: user.id,
          props: {
            position: {
              x: value.x,
              y: value.y,
              z: value.z,
            },
          },
          callback: (response) => {
            GraphicClient.sendMessage(
              MessageType.USER,
              UserSendMessageType.UPDATE_USER,
              response.data
            );
          },
          callbackError: (error) => {
            console.error(error);
          },
        });
        break;
      }
      case UserReceiveMessageType.USER_BAN: {
        store?.dispatch("SystemStore/setConfirmModalBanAction", true);
        store?.dispatch("SystemStore/setConfirmBanModalDataAction", value);
        break;
      }
      case UserReceiveMessageType.USER_CONNECT_TO_ROOM_AUTO_VIDEO: {
        const space = store?.getters["SpaceStore/getSpace"];
        if (space && space.superSpace && space.superSpace.company !== "CTTI")
          return;
        store.dispatch("MeetingStore/setRoomAutoVideoIdAction", value);
        store.dispatch("SystemStore/setShowAutoVideoEnterModalAction", true);
        break;
      }
      case UserReceiveMessageType.USER_DISCONNECT_FROM_ROOM_AUTO_VIDEO: {
        const space = store?.getters["SpaceStore/getSpace"];
        if (space && space.superSpace && space.superSpace.company !== "CTTI")
          return;
        await store.dispatch("MeetingStore/setRoomAutoVideoIdAction", null);
        await store.dispatch("SystemStore/setShowAutoVideoEnterModalAction", false);
        await store.dispatch("SystemStore/setAutoVideoAction", false);
        await store?.dispatch("MeetingStore/setRoomNameAction", "");
        await store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
        await store?.dispatch("MeetingStore/setIsFirstConnectionAction", false);
        await store?.dispatch("SidebarStore/setOpenCall", false);
        await store?.dispatch("MeetingStore/setMeetingTypeAction", "");
        break;
      }
      default: {
        console.error(`${message} is not defined in userMessageHandler method`);
        break;
      }
    }
  }
  async pollUpdate(store, data) {
    let poll = {
      id: data.poll.id,
      hasUserVoted: data.poll.hasUserVoted,
      room: {
        id: data.id,
      },
      pollOptions: data.poll.pollOptions,
      question: data.poll.question,
      status: data.poll.status,
      duration: data.poll.duration,
      timeLeft: data.poll.timeLeft
    }
    let response = {
      data: poll
    }
    await RoomSocketHandler.pollUpdate(store, response);
  }
}
